import AnnouncementBar from "@stadium/ui/src/components/announcement-bar";

import { useCreateSwagContext } from "@contexts/create-swag-context";
import { useState, useEffect } from "react";

const AddProductsToCatalogBanner = () => {
  const { currentUserConfig, modifyUser } = useCreateSwagContext();

  const [isOpen, setIsOpen] = useState(false);

  const handleCloseBanner = () => {
    modifyUser({ variables: { input: { automatedCatalogBannerDismissed: true } } });
    setIsOpen(false);
  };

  useEffect(() => {
    if (currentUserConfig?.id && !currentUserConfig?.automatedCatalogBannerDismissed) {
      setIsOpen(true);
    }
  }, [currentUserConfig?.id]);

  if (!isOpen) return null;

  return (
    <AnnouncementBar color="blue" showCross handleOnCloseClick={handleCloseBanner}>
      <span>Add products from our catalog to start designing your swag.</span>
    </AnnouncementBar>
  );
};

export default AddProductsToCatalogBanner;
